import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const AdminCircles = lazy(() => import("@/pages/admin/AdminCircles"));

export const Route = createFileRoute("/admin/circles")({
  component: AdminCircles,
});
